<template>
  <UButton class="flex md:inline-flex justify-center md:ml-auto" color="black" size="xl">
    <i
      class="fas text-sm hidden xs:inline-block"
      :class="{
        'fa-lock': restricted,
        'fa-filter': !restricted,
      }"
    ></i>
    <span class="text-sm">
      Advanced
      <span class="hidden xs:inline">Filters </span>
      <template v-if="!restricted && activeFiltersCount">({{ activeFiltersCount }})</template>
    </span>
  </UButton>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{ activeFiltersCount?: number; restricted?: boolean }>(), {
  activeFiltersCount: 0,
});
</script>
